import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Raffle.MoveDialog;

export const getRaffleMoveTicketsSchema = (
  t: TFunction,
  myTicketCount: number,
) => {
  const countMessage = t(RESOURCES.CountHelper, { max: myTicketCount });

  return z.object({
    toRoundPublicID: z.string().min(1),
    count: z
      .number()
      .int(countMessage)
      .min(1, countMessage)
      .max(myTicketCount, countMessage),
  });
};

export type RaffleMoveTicketsFormData = z.infer<
  ReturnType<typeof getRaffleMoveTicketsSchema>
>;
